import { useEffect, useState } from "react";
import { Route, Routes, useParams, useRoutes } from "react-router-dom";
import "./i18n";
import "./style.css";
import routes from "./routes";
import AppProvider from "./AppProvider";
import { useSnackbar } from "notistack";
import SnackbarUtils from "./utils/SnackbarUtils";
import { Fade, IconButton } from "@mui/material";
import { CloseOutlined } from "@mui/icons-material";
import Notibar from "./utils/Notibar";
import { getAccessToken, updateCustomer } from "./api/APIs";
import initialize from "./utils/initialize";
import SplashScreen from "./components/SplashScreen";
import { useDispatch, useSelector } from "./store";
import {
  getBluebonnetPlan,
  getUtilityCode,
  initialLoad,
  setAppLoading,
} from "./slices/bkvReducer";
import constants from "./constants";
import useIsMountedRef from "./hooks/useIsMountedRef";
import { useCookies } from "react-cookie";

const routeComponent = routes.map(({ path, Component }, key) => (
  <Route path={path} element={<>{Component}</>} />
));
const action = (key) => (
  <>
    <IconButton
      onClick={() => {
        SnackbarUtils.closeSnackbar(key);
      }}
      style={{ color: "white" }}
    >
      <CloseOutlined color="inherit" />
    </IconButton>
  </>
);

const App = () => {
  const [cookies, setCookie, removeCookie] = useCookies(["ref_promo"]);

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const mountRef = useIsMountedRef();
  const [loading, setLoading] = useState(true);
  const searchParams = new URLSearchParams(window.location.search);
  const zipcode = searchParams.get("zipcode") ?? "77005";
  const terms = constants.defaultTerms;
  //const promocode = searchParams.get("promocode") ?? "";
  const promocode = "SEOEIQ0001";
  const state = useSelector((state) => state.bkv);
  const dispatch = useDispatch();
  const urlParam = useParams();
  const planType = "bluebonnet-vs-Polyedra";

  useEffect(() => {
    SnackbarUtils.setSnackBar(enqueueSnackbar, closeSnackbar, action, Fade);
  }, []);

  useEffect(() => {
    if (!mountRef.current) {
      mountRef.current = true;
    } else {
      if (state.gimmicky?.ProductId) {
        const itemRef = document.getElementById(state.gimmicky.ProductId);
        if (itemRef) {
          itemRef.scrollIntoView({
            block: "center",
          });
        }
      }
    }
  }, [state.gimmicky?.ProductId]);

  // useEffect(() => {
  //   removeCookie("ref_promo", { path: "/", domain: ".localhost" });
  //   // Set the promo code in the cookie
  //   setCookie("ref_promo", "SEOEIQ0001", {
  //     path: "/",
  //     domain: ".localhost", // Corrected domain
  //     expires: new Date(Date.now() + 7 * 24 * 60 * 60 * 1000),
  //   });
  // }, []);

  return (
    <AppProvider>
      <Routes>{routeComponent}</Routes>
    </AppProvider>
  );
};

export default App;
